import {
  configurationPageTitles,
  CartItemImages,
  configurationPageServiceCardProgram,
} from '@lib/constants/gift-card-type-constants';
import { CARD_PROGRAMS, FLIP_GIVE } from '@lib/constants';
import { LET_THEM_CHOOSE } from '@lib/constants/variants';
import { getFGToken, getReferral } from '@lib/util/local-storage';

const letThemChooseUtil = {
  async getGiftCardTypes(giftCard: any): Promise<string[]> {
    if (giftCard?.length === 0) {
      return [];
    }
    return giftCard.map((card: any) => card.key);
  },

  getGiftCardImageAndTitle(cardProgram: string, availableCyoThemeCards?: any[]) {
    const cardSelect = (availableCyoThemeCards??[]).find((card: any) => card.key === cardProgram ?? '');
    const title = cardSelect ? configurationPageTitles[cardSelect.mccCategory] : '';
    const img_url = cardSelect ? cardSelect.imageConfigurationFullPath: '';
    return { title: title , img_url };
  },

  getDescription(cardProgram: string, configurationPageDescriptions: any) {
    return configurationPageDescriptions?.[cardProgram] ?? '';
  },

  getCartItemImage(cardProgram: string | undefined, configurationPageImages: any) {
    return configurationPageImages?.[cardProgram ?? ''] ?? CartItemImages[CARD_PROGRAMS.CHOOSE_YOUR_OWN_RESTAURANT];
  },

  getCardProgramForConfigurationPage(ref: string, search: string) {
    if (ref !== FLIP_GIVE) return CARD_PROGRAMS.CHOOSE_YOUR_OWN_RESTAURANT;

    return configurationPageServiceCardProgram[search ?? ''] ?? CARD_PROGRAMS.CHOOSE_YOUR_OWN_RESTAURANT;
  },

  isFlipGive() {
    const currentRef = getReferral();
    return currentRef === FLIP_GIVE;
  },

  getFlipGiveToken() {
    return getFGToken();
  },

  getBusinessName(
    card_program: string | undefined,
    business_name: string | undefined,
    hasA: boolean = false,
    isYour: boolean = false,
    availableCyoThemeCards?: any[]
  ) {
    if (business_name && business_name != LET_THEM_CHOOSE) return business_name;

    const aText = hasA ? 'a ' : '';
    const yourText = isYour ? 'Your' : 'Their';
    const cardSelect = availableCyoThemeCards?.find((card: any) => card.key === card_program);
    return `${aText} ${cardSelect?.usageLocationText} of ${yourText} Choice`;
  },
};

export default letThemChooseUtil;
